var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { SafariWriteDirectionUtility } from '@inter-ikea-kompis/utilities';
import { FocusOutlinePositionWatcherEnum } from '@inter-ikea-kompis/component-focus-outline';
import { FocusOutline } from '@inter-ikea-kompis/component-focus-outline';
import { Icon } from '@inter-ikea-kompis/component-icon';
import { LoadingBall as SkapaLoadingBall } from '@ingka/loading-webc/passive.js';
import IconButtonSizeEnum from '../../enums/IconButtonSizeEnum.js';
import IconButtonStyle from './IconButtonStyle.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 * IconButton class.
 *
 * @event click Triggered when button is clicked.
 */
export default class IconButton extends KompisElement {
    constructor() {
        super(...arguments);
        // Svg icon
        this.icon = null;
        // Renders the loading style
        this.loading = false;
        // True if the button is disabled
        this.disabled = false;
        // Inverted Colors mode
        this.invertedColors = false;
        // Flip the icon horizontally in RTL context
        this.flipIconRtl = false;
        // Type of icon button style
        this.type = 'primary';
        // Size of the icon button
        this.size = IconButtonSizeEnum.medium;
        // Accessibility description that will be set as an "aria-label" attribute on the icon button.
        this.ariaLabel = null;
        // Sets the behaviour of the position watcher. The position watcher is useful when the component is inside an overflown element where it can become cropped. When enabled it will be set itself to be position fixed and update the position of itself live. However, updating the position live can be slow and result in lag on slower computers. Be wary of using 'auto' or 'enabled' if the component have any ancestors with transform styling.
        this.focusOutlinePositionWatcher = FocusOutlinePositionWatcherEnum.auto;
    }
    render() {
        const direction = SafariWriteDirectionUtility.getWriteDirection(this);
        return html `
			<style>
				${IconButtonStyle.getStyle({
            isDisabled: this.disabled,
            isLoading: this.loading,
            buttonType: this.type,
            icon: this.icon,
            size: this.size,
            theme: this.theme,
            invertedColors: this.invertedColors,
            direction: direction
        })}
			</style>

			<kompis-focus-outline
				.theme="${this.theme}"
				.positionWatcher="${this.focusOutlinePositionWatcher}"
				.invertedColors="${this.invertedColors}"
			>
				<button
					@mousedown="${(event) => event.preventDefault()}"
					autocomplete="off"
					aria-busy="${this.loading}"
					?disabled="${this.disabled || this.loading}"
				>
					<div class="outline"></div>
					<span class="visuallyHidden">${this.ariaLabel ? this.ariaLabel : null}</span>
					${this.getIcon()} ${this.getLoadingIcon()}
				</button>
			</kompis-focus-outline>
		`;
    }
    async connectedCallback() {
        this.customElements.define('skapa-loading-ball', SkapaLoadingBall);
        this.customElements.define('kompis-icon', Icon);
        this.customElements.define('kompis-focus-outline', FocusOutline);
        super.connectedCallback();
    }
    /**
     * Returns icon.
     *
     * @returns Template.
     */
    getIcon() {
        if (!this.icon) {
            return null;
        }
        return html `<kompis-icon
			class="icon"
			.theme="${this.theme}"
			.icon="${this.icon}"
			.flipIconRtl="${this.flipIconRtl}"
		></kompis-icon> `;
    }
    getLoadingIcon() {
        if (!this.loading || this.disabled) {
            return null;
        }
        return html `
			<div class="loading-indicator-container">
				<skapa-loading-ball
					.colour="${this.getLoadingIndicatorColor()}"
					?small="${this.size === IconButtonSizeEnum.small ||
            this.size === IconButtonSizeEnum.xsmall}"
					?medium="${this.size === IconButtonSizeEnum.medium}"
				>
				</skapa-loading-ball>
			</div>
		`;
    }
    getLoadingIndicatorColor() {
        switch (this.type) {
            case 'primary':
            case 'emphasised':
                return this.invertedColors ? 'primary' : 'secondary';
            case 'secondary':
            case 'tertiary':
                return this.invertedColors ? 'secondary' : 'primary';
            default:
                return 'secondary';
        }
    }
}
__decorate([
    property({ type: String })
], IconButton.prototype, "icon", void 0);
__decorate([
    property({ type: Boolean })
], IconButton.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean })
], IconButton.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], IconButton.prototype, "invertedColors", void 0);
__decorate([
    property({ type: Boolean })
], IconButton.prototype, "flipIconRtl", void 0);
__decorate([
    property({ type: String })
], IconButton.prototype, "type", void 0);
__decorate([
    property({ type: String })
], IconButton.prototype, "size", void 0);
__decorate([
    property({ type: Object, required: true })
], IconButton.prototype, "theme", void 0);
__decorate([
    property({ type: String })
], IconButton.prototype, "ariaLabel", void 0);
__decorate([
    property({ type: String })
], IconButton.prototype, "focusOutlinePositionWatcher", void 0);
//# sourceMappingURL=IconButton.js.map